
import { computed, PropType, defineComponent, provide } from "vue";
import { useStore } from "@/store";
import { Slide } from "@/types/slides";
import useSlideBackgroundStyle from "@/hooks/useSlideBackgroundStyle";
import { injectKeySlideScale } from "@/types/injectKey";
import ThumbnailElement from "./ThumbnailElement.vue";

export default defineComponent({
  name: "thumbnail-slide",
  components: {
    ThumbnailElement,
  },
  props: {
    slide: {
      type: Object as PropType<Slide>,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
    ratio: {
      type: Number,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const viewportRatio = computed(() => store.state.viewportRatio);
    const viewportWidths = computed(() => store.state.viewportWidth);

    const background = computed(() => props.slide.background);
    const { backgroundStyle } = useSlideBackgroundStyle(background);

    const scale = computed(() => props.size / viewportWidths.value);
    provide(injectKeySlideScale, scale);
    return {
      scale,
      backgroundStyle,
      viewportWidths,
      viewportRatio,
    };
  },
});
